module.exports = __webpack_public_path__ + "img/visa.641e79e4.svg";